import { useState } from 'react';

export default function useShare() {
  const [isLoading, setLoading] = useState(false);
  const [canShare, setCanShare] = useState(false);
  const [shareData, setShareData] = useState<ShareData | undefined>(undefined);

  const share = async () => {
    if (shareData && canShare) {
      setLoading(true);
      try {
        await navigator.share(shareData);
      } catch (error) {
        console.error('Error sharing:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const validateShareData = (shareData: ShareData | undefined) => {
    if (typeof navigator.canShare === 'function' && navigator.canShare(shareData)) {
      setShareData(shareData);
      setCanShare(true);
    }
  };

  return {
    canShare,
    isLoading,
    share,
    isSharing: isLoading,
    validateShareData,
  };
}
